import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OrderDisplay from './order-display';


/**
 * Render Message Component
 *
 * @class Message
 * @public
 *
 * @returns {React.ReactElement}
 */

class Message extends Component {
  render() {
    const {
      email,
      contactOptOut,
      contactPreferences,
      order,
      orderTotal,
      orderTotalPrefix,
      receiptUrl,
      preferenceUrl,
      printReceipt
    } = this.props;

    return (
      <div>
        { email && <p className='font-base'>{ email }</p> }
        { preferenceUrl && contactPreferences && contactOptOut && (
          <p>
            <span>{ contactOptOut }</span>
            <a href={ preferenceUrl } target='_blank' rel='noopener noreferrer'>
              <span className='link-style contact-preferences'>
                { contactPreferences }
              </span>
            </a>
          </p>
        )}
        { order && <OrderDisplay { ...order } /> }
        { orderTotal && orderTotalPrefix && (
          <p>
            <span className='font-base'>
              { orderTotalPrefix } <strong>{ orderTotal }</strong>
            </span>
          </p>
        )}
        { receiptUrl && printReceipt && (
          <span>
            <span className='uxicon uxicon-page' />
            <a href={ receiptUrl } target='_blank' rel='noopener noreferrer'>
              <span className='link-style receipt'>{ printReceipt }</span>
            </a>
          </span>
        )}
      </div>
    );
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */

Message.propTypes = {
  /** Ordering customers email */
  email: PropTypes.string,
  /** Opt out message before preferenceURL */
  contactOptOut: PropTypes.string,
  /** Anchor text for preference URL */
  contactPreferences: PropTypes.string,
  /** Order data */
  order: PropTypes.object,
  /** Entire order total */
  orderTotal: PropTypes.string,
  /** Phrase identifying order total (Ex: 'Here is the order total') */
  orderTotalPrefix: PropTypes.string,
  /** URL for altering preference data */
  preferenceUrl: PropTypes.string,
  /** Link to print receipt */
  printReceipt: PropTypes.string,
  /** Link for getting receipt */
  receiptUrl: PropTypes.string
};

export default Message;
